module.exports = __webpack_public_path__ + "media/images/application/subscribe/image-unsubscribe-82b926604abfd6aec893bf910bad2535.svg";